import { Component, Input, OnInit } from '@angular/core';
import { CustomerConst } from '@app/constants/customer-const';
import { CustomerIdentity } from "@app/models/customer-identity";
import { IdentityService } from '@app/services/identity.service';

@Component({
    selector: 'app-identity-documents',
    templateUrl: './identity-documents.component.html',
    styleUrls: ['./identity-documents.component.css'],
    standalone: false
})
export class IdentityDocumentsComponent implements OnInit {

  @Input() item: CustomerIdentity;
  @Input() isShowDialog: boolean;
  @Input() titleDialog: string;
  @Input() srcImageDialog: string;
  @Input() checkIdentityRequired!: (type: string) => boolean;
  @Input() tooltipText: string;

  constructor(private identityService: IdentityService
              ) { }

  showImage(title, src) {
    this.isShowDialog = true;
    this.titleDialog = title;
    this.srcImageDialog = src;
  }

  ngOnInit(): void {
    this.downloadFile(this.item, CustomerConst.IDENTITY_DOCUMENT.OTHER);
  }

  downloadFile(identityItem, type) {
    if (identityItem?.identityDocuments) {
      let idOfType = identityItem.identityDocuments.find(p => p.type == type)
      if (idOfType?.url && (!identityItem.imageSrcImage || !identityItem.imageSrcImage[type])) {
        this.identityService.download(idOfType.url).subscribe({
          next: (blob) => {
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              let base64data = reader.result as string;
              if (!identityItem.imageSrcImage) {
                identityItem.imageSrcImage = new Object();
              }
              identityItem.imageSrcImage[type] = base64data.replace('data:application/octet-stream;', 'data:image/png;');
            }
          }
        });
      }
    }
  }

  isSignatureIdentity(identityItem: CustomerIdentity): boolean {
    if (!identityItem) return false;
    if (identityItem.type !== CustomerConst.IDENTITY_TYPE.SIGNATURE) return false;
    if (identityItem.imageSrcImage?.[CustomerConst.IDENTITY_DOCUMENT.SIGNATURE]) return true;
    return !!identityItem.identityDocuments?.some(doc => doc.type === CustomerConst.IDENTITY_DOCUMENT.SIGNATURE);
  }

}
